<script>
import advancedIFrameMixin from '@phoenix/mixins/advancedIframeMixin';
import { PhxsgLoader } from '@sg/src/View/Components/Atoms/Loader';

export default {
  components: { PhxsgLoader },

  mixins: [advancedIFrameMixin],
};
</script>

<template>
  <component :is="currentComponent" :class="{ container: hasContainer }">
    <div class="phoenix-advanced-iframe__wrapper">
      <div v-if="shouldDisplayLoader" class="phoenix-advanced-iframe__loader">
        <phxsg-loader size="lg" />
      </div>

      <iframe
        :id="id"
        v-resize="resizeOptions"
        data-cy="advanced-iframe"
        :src="iframeUrl"
        width="100%"
        @load="onIframeLoad"
      ></iframe>
    </div>
  </component>
</template>

<style>
.phoenix-advanced-iframe__wrapper {
  min-height: 50vh;
  position: relative;
  width: 100%;
}

.phoenix-advanced-iframe__loader {
  align-items: center;
  background: var(--color-background);
  display: flex;
  inset: 0;
  justify-content: center;
  pointer-events: none;
  position: absolute;
  z-index: 2;
}

.phoenix-advanced-iframe__wrapper iframe {
  border: none;
  position: relative;
  width: 100%;
  z-index: 1;
}
</style>
